import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Media from '@/components/material-ui-kit/components/Media/Media';
import Button from '@/components/material-ui-kit/components/CustomButtons/Button';
import Tooltip from '@material-ui/core/Tooltip';
import styles from 'styles/jss/original/components/shoppings/shoppingCommentTimelineItem';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import Linkify from 'react-linkify';
import { Comment } from '@/domains/firestore/comment';

dayjs.locale('ja');

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  comment: Comment;
  onRequestUpdateLike: (id: string) => void;
  isLiked: boolean;
  invalid: boolean;
};

const ShoppingCommentTimelineItem: React.FC<ComponentProps> = ({
  comment,
  onRequestUpdateLike,
  isLiked,
  invalid
}) => {
  const classes = useStyles();
  const date = dayjs(comment.timestamp).format('YYYY年MM月DD日');
  const handleClick = useCallback(
    (commentId) => {
      onRequestUpdateLike(commentId);
    },
    [onRequestUpdateLike]
  );

  return (
    <Media
      avatar={comment.user.img}
      title={
        <span className={classes.user}>
          {comment.user.name}
          <small className={classes.date}>{date}</small>
        </span>
      }
      body={
        <p className={classes.message}>
          <Linkify>
            {comment.message.split('\n').map((str, index) => (
              <React.Fragment key={index}>
                {str}
                <br />
              </React.Fragment>
            ))}
          </Linkify>
        </p>
      }
      footer={
        <div>
          <p className={classes.good}>
            <span className={classes.goodText}>参考になった</span>
            <Tooltip
              id='tooltip-top'
              title='いいね'
              placement='top'
              classes={{ tooltip: classes.tooltip }}
            >
              {/* @ts-expect-error */}
              <Button
                simple
                className={classes.footerButtons}
                color={isLiked ? 'warning' : 'white'}
                link={!isLiked}
                disabled={invalid}
                onClick={() => handleClick(comment.commentId)}
              >
                <i className='fas fa-thumbs-up' />
              </Button>
            </Tooltip>
            <span className={classes.goodCount}>{comment.likedCount}</span>
          </p>
        </div>
      }
      key={comment.commentId}
    />
  );
};

export default ShoppingCommentTimelineItem;
